import changelog from "../../../../../pages/personalisation/docs/changelog-personalisation-client.json5";
import * as React from 'react';
export default {
  changelog,
  React
};